/**
 * Ob ein Formularfeld sichtbar ist.
 *
 * Diese Pruefung stand vierfach im Code - in den drei Formularen und in der
 * Vorschau - und war dabei nicht einmal gleich: die Vorschau verglich
 * grosszuegig, die Formulare mit ===. Ein Feld konnte in der Vorschau
 * erscheinen und im echten Antrag fehlen.
 *
 * Zwei Arten von Bedingung:
 *   { field, equals }   - das Feld hat genau diesen Wert
 *   { field, notEmpty } - im Feld steht ueberhaupt etwas
 */
export const istSichtbar = (feld, werte) => {
    const bedingung = feld?.showIf;
    if (!bedingung) return true;

    const ist = werte?.[bedingung.field];

    if (bedingung.notEmpty) {
        if (Array.isArray(ist)) return ist.length > 0;
        if (typeof ist === 'boolean') return ist;
        return String(ist ?? '').trim() !== '';
    }

    // Grosszuegig vergleichen: in der Datenbank steht "true" als Text, im
    // Formular ein echter Wahrheitswert. Ein strenger Vergleich wuerde die
    // Bedingung stillschweigend nie erfuellen.
    const soll = bedingung.equals;
    if (typeof soll === 'boolean') return !!ist === soll;
    return String(ist ?? '') === String(soll);
};

export default istSichtbar;
